import { faPlus, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import useAxios from "../../../../../MainComponents/Hooks/useAxios.jsx";

function AddSetsForm({ type, id, refetch, setRefetch }) {
  function reducer(state, action) {
    switch (action.type) {
      case "setSubmitAddSets": {
        return {
          ...state,
          submitAddSets: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddSets: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    control,
  } = useForm({
    defaultValues: {
      sets: [{ category_id: "", easy: "", medium: "", hard: "" }],
    },
    mode: "onTouched",
  });

  const { fields, append, remove } = useFieldArray({
    name: "sets",
    control,
  });

  //!--------- question bank categories for the sets form

  const [AllCategoriesSuccess, AllCategoriesErrors, AllCategoriesLoading] =
    useAxios(process.env.REACT_APP_ADMIN_SETS_CATEGORIES_API, "GET", "GET");

  //!--------- add questions to  quiz / homework   -------
  let addSetsApi =
    type === "homework"
      ? process.env.REACT_APP_ADMIN_SESSION_ADD_SETS_API
      : type === "exam"
      ? process.env.REACT_APP_EXAM_ADD_SETS_API
      : process.env.REACT_APP_ADMIN_SESSION_ADD_SETS_API;

  const [AddSetsSuccess, AddSetsErrors, submitLoading] = useAxios(
    addSetsApi,
    "POST",
    state.submitAddSets.flag,
    state.submitAddSets.dependency,
    state.submitAddSets.data,
    true
  );
  useEffect(() => {
    //!---add actions ----
    if (AddSetsSuccess) {
      reset();
      setRefetch(!refetch);
    }
  }, [AddSetsSuccess]);

  const onSubmitAddSets = (data) => {
    let finalData = data?.sets?.map((set) => ({ content_id: id, ...set }));

    if (type === "exam") {
      finalData = data?.sets?.map((set) => ({
        exam_id: id,
        ...set,
      }));
    }
    dispatch({
      type: "setSubmitAddSets",
      payload: {
        flag: "Quiz",
        dependency: !state.submitAddSets.dependency,
        data: { sets: finalData },
      },
    });
  };

  return (
    <div className="admin-sets-form flex w-full justify-center">
      <form
        onSubmit={handleSubmit(onSubmitAddSets)}
        method="post"
        className="admin-sets-form__card flex w-3/4 alg:w-full flex-col items-stretch gap-6 rounded-2xl p-8 md:p-6 shadow-lg"
      >
        {fields.map((field, index) => {
          return (
            <div
              key={field.id}
              className="admin-sets-form__row flex w-full items-end justify-between gap-4 md:flex-col md:items-stretch"
            >
              <div className="delete-set shrink-0 pb-1">
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className={`admin-sets-form__delete group rounded-md px-2 py-2 duration-300 hover:bg-secondary hover:text-white active:scale-90 ${
                    index === 0 && "pointer-events-none opacity-0"
                  }`}
                >
                  <FontAwesomeIcon
                    className="text-lg duration-300"
                    icon={faTrash}
                  />
                </button>
              </div>

              <div className="admin-sets-form__field flex w-1/4 min-w-0 flex-col items-start justify-center gap-2 md:w-full">
                <label htmlFor={`category_${index + 1}`}>Category</label>
                <select
                  className="admin-sets-form__control"
                  name={`category_${index + 1}`}
                  id={`category_${index + 1}`}
                  {...register(`sets.${index}.category_id`, {
                    required: {
                      value: true,
                      message: "category id is required",
                    },
                  })}
                >
                  <option value="" disabled>
                    Select Category
                  </option>
                  {AllCategoriesSuccess?.data?.map((category_id) => (
                    <option key={category_id.key} value={category_id.key}>
                      {category_id.title}
                    </option>
                  ))}
                </select>
                {errors?.sets?.[index]?.category_id && (
                  <p className="text-xs text-red-500">
                    {errors?.sets?.[index]?.category_id.type === "required" &&
                      "This field is required."}
                  </p>
                )}
                {AddSetsErrors &&
                  AddSetsErrors?.response?.data?.errors?.sets?.[index]
                    ?.category_id && (
                    <p className="text-xs text-red-500">
                      {
                        AddSetsErrors?.response?.data?.errors?.sets?.[index]
                          ?.category_id[0]
                      }
                    </p>
                  )}
              </div>

              <div className="admin-sets-form__field flex w-1/4 flex-col items-start justify-center gap-2 md:w-full">
                <label htmlFor={`easy_${index + 1}`}>Easy</label>
                <input
                  className="admin-sets-form__control"
                  type="number"
                  id={`easy_${index + 1}`}
                  placeholder="Easy"
                  autoComplete="on"
                  {...register(`sets.${index}.easy`, {
                    required: true,
                  })}
                />
                {errors?.sets?.[index]?.easy && (
                  <p className="text-xs text-red-500">
                    {errors?.sets?.[index]?.easy.type === "required" &&
                      "This field is required."}
                  </p>
                )}
                {AddSetsErrors &&
                  AddSetsErrors?.response?.data?.errors?.sets?.[index]
                    ?.easy && (
                    <p className="text-xs text-red-500">
                      {
                        AddSetsErrors?.response?.data?.errors?.sets?.[index]
                          ?.easy[0]
                      }
                    </p>
                  )}
              </div>

              <div className="admin-sets-form__field flex w-1/4 flex-col items-start justify-center gap-2 md:w-full">
                <label htmlFor={`medium_${index + 1}`}>Medium</label>
                <input
                  className="admin-sets-form__control"
                  type="number"
                  id={`medium_${index + 1}`}
                  placeholder="Medium"
                  autoComplete="on"
                  {...register(`sets.${index}.medium`, {
                    required: true,
                  })}
                />
                {errors?.sets?.[index]?.medium && (
                  <p className="text-xs text-red-500">
                    {errors?.sets?.[index]?.medium.type === "required" &&
                      "This field is required."}
                  </p>
                )}
                {AddSetsErrors &&
                  AddSetsErrors?.response?.data?.errors?.sets?.[index]
                    ?.medium && (
                    <p className="text-xs text-red-500">
                      {
                        AddSetsErrors?.response?.data?.errors?.sets?.[index]
                          ?.medium[0]
                      }
                    </p>
                  )}
              </div>

              <div className="admin-sets-form__field flex w-1/4 flex-col items-start justify-center gap-2 md:w-full">
                <label htmlFor={`hard_${index + 1}`}>Hard</label>
                <input
                  className="admin-sets-form__control"
                  type="number"
                  id={`hard_${index + 1}`}
                  placeholder="Hard"
                  autoComplete="on"
                  {...register(`sets.${index}.hard`, {
                    required: true,
                  })}
                />
                {errors?.sets?.[index]?.hard && (
                  <p className="text-xs text-red-500">
                    {errors?.sets?.[index]?.hard.type === "required" &&
                      "This field is required."}
                  </p>
                )}
                {AddSetsErrors &&
                  AddSetsErrors?.response?.data?.errors?.sets?.[index]
                    ?.hard && (
                    <p className="text-xs text-red-500">
                      {
                        AddSetsErrors?.response?.data?.errors?.sets?.[index]
                          ?.hard[0]
                      }
                    </p>
                  )}
              </div>
            </div>
          );
        })}

        <div className="admin-sets-form__actions flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() =>
              append({ category_id: "", easy: "", medium: "", hard: "" })
            }
            className="admin-sets-form__add-category rounded-xl border-2 border-secondary bg-secondary px-3 py-1.5 font-semibold text-white transition-all duration-300 hover:bg-transparent hover:text-secondary active:scale-90"
          >
            Add Category
            <FontAwesomeIcon className="ml-2" icon={faPlus} />
          </button>
        </div>

        <button
          disabled={!isValid || (submitLoading && state.submitAddSets.flag)}
          className="admin-sets-form__submit mt-2 w-full"
          type="submit"
        >
          {submitLoading && state.submitAddSets.flag ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : (
            "Add Questions"
          )}
        </button>
      </form>
    </div>
  );
}

export default AddSetsForm;
